module.exports = "../../../../platform/assets/pageMainIcon/simple_danjuweihulei4.svg";